import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import SearchBar from "../../../../components/Searchbar/searchbar";

// Table
import TableContainer from "@material-ui/core/TableContainer";
import Tablestyles from "../../ROCITable.module.css";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import classNames from "classnames";
import TablePagination from "@material-ui/core/TablePagination";

// Dialog
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@material-ui/core/Button";
import ViewRecord from "../../../../components/modal/ViewRecord";
import Filters from "./Filters";
import CreateNewRecord from "../../../../components/modal/CreateNewRecord";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
    width: "auto", // let content decide
    minWidth: "30px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  body: {
    fontSize: 12,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    width: "auto", // let content decide
    minWidth: "30px",
    maxWidth: "250px",
    whiteSpace: "normal",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

const Row = ({
  keys,
  index,
  rowData,
  headingRow,
  handleEditRow,
  handleDeleteRow,
  updateSourceInputs,
  classes,
  tableName,
  sourceData,
  setIsDeleteDialogOpen,
  setCurrentDeletingRowData,
  setOpenFullRecordModal,
  setCurrentRecord,
  setIsEditMode,
}) => {
  const RowData = rowData?.rowData || {};
  const handleEditingRow = (mode) => {
    const isEdit = mode !== "readOnly";
    if (isEdit) {
      setIsEditMode(true);
    } else {
      setIsEditMode(false);
    }
    setOpenFullRecordModal(true);
    setCurrentRecord(rowData);
  };

  const handleRowDelete = () => {
    setIsDeleteDialogOpen(true);
    setCurrentDeletingRowData(rowData);
  };

  return (
    <TableRow
      key={`Rowkey-${keys}`}
      style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f7f7f7" }}
    >
      {headingRow.map(({ label, name }, indexs) =>
        name !== "actions" ? (
          <>
            <StyledTableCell
              key={`key-${indexs}`}
              className={classNames(
                classes.tableBodyCell,
                `tableBodyCell_${tableName}`,
              )}
              onClick={() => handleEditingRow("readOnly")}
              style={{ cursor: "pointer" }}
            >
              <div
                className="scrollable-cell cell-wrapper"
                style={{
                  position: "relative",
                  width: "100%",
                  padding: "2px 3px",
                  border:
                    RowData?.[name]?.length > 50 ? "1px solid #e0e0e0" : "none",
                  overflowX: RowData?.[name]?.length > 50 ? "auto" : "visible",
                  whiteSpace: "nowrap",
                  display: "block",
                  textWrap: "wrap",
                  // cursor: "pointer",
                }}
                // onClick={handleEditingRow}
              >
                <span>
                  {Array.isArray(RowData?.[name]) && RowData?.[name]?.length > 0
                    ? RowData?.[name]?.join(", ") || ""
                    : ""}
                  {!Array.isArray(RowData?.[name]) &&
                  RowData?.[name]?.length > 0 &&
                  RowData?.[name] !== "null"
                    ? RowData?.[name]
                    : ""}
                </span>
              </div>
            </StyledTableCell>
          </>
        ) : (
          // Actions buttons
          <StyledTableCell
            className={classNames(
              classes.tableBodyCell,
              `tableBodyCell_${tableName}`,
            )}
          >
            <div className="action-icon-container">
              <span>
                <i
                  className="material-icons-outlined "
                  onClick={() => handleEditingRow("edit")}
                  style={{ cursor: "pointer" }}
                >
                  edit
                </i>
              </span>
              <span>
                <i
                  className="material-icons-outlined"
                  style={{ color: "red" }}
                  onClick={handleRowDelete}
                >
                  delete
                </i>
              </span>
            </div>
          </StyledTableCell>
        ),
      )}
    </TableRow>
  );
};

function TableView(props) {
  const {
    classes = {},
    tableName,
    source_data = {},
    TableData,
    handleEditRow,
    handleDeleteRow,
    handleUpdateRow,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    isRowDataUpdating,
    setIsRowDataUpdating,
    setTableData,
    updateSourceInputs,
    tableHeadColumns,
    editModelColumnList,
    updateAlert,
    children,
    usecase,
    handleCreateNewRow,
    usecaseLabel,
    ...rest
  } = props;

  const [searchValue, setSearchValue] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [currentDeletingRowData, setCurrentDeletingRowData] = useState(null);
  const [openFullRowRecordModal, setOpenFullRecordModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(false);
  const [paginatedRows, setPaginatedRows] = useState(
    source_data?.current_mapped_data?.slice(0, rowsPerPage),
  );
  const [isOpen, setIsOpen] = useState(false);
  const DROPDOWN_DATA = source_data?.data?.dropdown || {};
  const EDIT_MODEL_COLUMN_LIST = DROPDOWN_DATA?.edit_column_model_list || [];

  const outlinedCNCButton = {
    borderColor: "#46596A",
    color: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const handleEdit = () => {
    handleEditRow();
  };

  const handleDelete = async () => {
    const MODIFIED_MAPPED_DATA = source_data?.modified_mapped_data;
    const Updated_Modified_data = MODIFIED_MAPPED_DATA.filter((item) => {
      const updated = item?.updated || {};
      const isEditedRowData =
        source_data?.data?.dropdown?.duplicate_validation_attributes?.every(
          (key) => {
            return updated?.[key] === currentDeletingRowData?.rowData?.[key];
          },
        );

      return !isEditedRowData && item;
    });

    updateSourceInputs("modified_mapped_data", Updated_Modified_data);
    const updated = source_data.current_mapped_data.filter(
      (item) => item.item_Id !== currentDeletingRowData?.item_Id,
    );
    const reindexed = updated.map((item, idx) => ({ ...item, item_Id: idx }));

    updateSourceInputs("current_mapped_data", reindexed);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isNewDataInserted", false);

    await handleDeleteRow(currentDeletingRowData.rowData);
    setIsDeleteDialogOpen(false);
    updateAlert({
      open: true,
      message: "RowData has been Deleted successfully",
      severity: "info",
      closeFlag: true,
    });
  };

  const handleCloseModel = () => {
    setCurrentRecord({});
    setOpenFullRecordModal(false);
  };

  // PAGINATIONS
  const handlePaginatedRows = (newPage, AllRowsData) => {
    const start = newPage * rowsPerPage;
    const end = start + rowsPerPage;
    const currentPageRows = AllRowsData
      ? AllRowsData.slice(start, end)
      : paginatedRows.slice(start, end);
    return currentPageRows;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const Paginated_Rows = handlePaginatedRows(newPage, TableData);
    setPaginatedRows(Paginated_Rows);
  };

  const handleChangeRowsPerPage = (e) => {
    const value = parseInt(e.target.value);
    setRowsPerPage(value);
    const start = 0 * value;
    const end = start + value;
    const currentPageRows = TableData.slice(start, end);
    setPaginatedRows(currentPageRows);
    setPage(0);
  };

  const handleSearchValue = (val) => {
    setPage(0);
    setRowsPerPage(10);
    if (!val || val.length === 0) {
      setSearchValue("");
      updateSourceInputs("searchValue", "");
      const Paginated_Rows = handlePaginatedRows(
        0,
        source_data.current_mapped_data,
      );
      setPaginatedRows(Paginated_Rows);
    } else {
      let filtered;
      if (source_data.filtered_Rows && source_data.filtered_Rows.length > 0) {
        filtered = source_data.filtered_Rows.filter((item) => {
          return source_data.data.dropdown.search_filter_attributes.some(
            (attribute) => {
              const Attribute_Value = Array.isArray(
                item?.rowData?.[attribute?.value],
              )
                ? item?.rowData?.[attribute?.value]?.join(", ") || ""
                : item?.rowData?.[attribute?.value] || "";
              return String(Attribute_Value)
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      } else {
        filtered = source_data.current_mapped_data.filter((item) => {
          return source_data.data.dropdown.search_filter_attributes.some(
            (attribute) => {
              const Attribute_Value = Array.isArray(
                item?.rowData?.[attribute?.value],
              )
                ? item?.rowData?.[attribute?.value]?.join(", ") || ""
                : item?.rowData?.[attribute?.value] || "";
              return String(Attribute_Value)
                .toLowerCase()
                .includes(val.toLowerCase());
            },
          );
        });
      }
      setSearchValue(val);
      updateSourceInputs("searchValue", val);
      const Paginated_Rows = handlePaginatedRows(0, filtered);
      setPaginatedRows(Paginated_Rows);
    }
  };

  const handleCreateRecord = () => {
    const INSERT_COLUMN_ATTRIBUTES =
      source_data?.data?.dropdown?.insert_column_attributes || {};
    const RECORDS = [
      INSERT_COLUMN_ATTRIBUTES,
      ...source_data?.current_mapped_data,
    ];

    let ItemId = 0;
    const FINAL_RECORDS = RECORDS.map((record, index) => {
      let data;
      if (Object.keys(record?.rowData || {})?.length > 0) {
        data = {
          ...record,
          item_Id: ItemId,
        };
      } else {
        data = {
          item_Id: ItemId,
          isNewData: true,
          isEdited: false,
          isEditing: false,
          isDeleted: false,
          rowData: record,
        };
      }
      ItemId++;
      return data;
    });
    updateSourceInputs("current_mapped_data", FINAL_RECORDS);
    setCurrentRecord(FINAL_RECORDS?.[0] || {});
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const Final_Paginated_rows = handlePaginatedRows(
      0,
      source_data.current_mapped_data,
    );
    setPaginatedRows(Final_Paginated_rows);
  }, [source_data.current_mapped_data, TableData]);

  return (
    <>
      {source_data?.current_mapped_data?.length > 0 && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <SearchBar
            handleSearchValue={handleSearchValue}
            placeholder={`Search with ${
              props?.source_data?.data?.dropdown?.search_filter_attributes
                ?.map((item) => item.label)
                ?.join(", ") || ""
            }`}
            value={props?.source_data?.searchValue ?? ""}
          />
          <div onClick={handleCreateRecord}>{children}</div>
        </div>
      )}

      <TableContainer className={Tablestyles.budget_tb2}>
        <Table
          stickyHeader
          className={classNames(classes.table, `table_${tableName}`)}
        >
          <TableHead className="table-heading">
            <TableRow
              className={classNames(
                classes.tableHeadRow,
                `tableHeadRow_${tableName}`,
              )}
            >
              {tableHeadColumns.map(({ label, name }, i) => (
                <StyledTableCell
                  key={i}
                  className={classNames(
                    classes.tableHeadCell,
                    classes[`tableHeadCell${name}`],
                    `tableHeadCell_${tableName} tableHeadCell_${name}`,
                  )}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginLeft: "3px",
                      cursor: "default",
                    }}
                  >
                    <span>{label}</span>
                  </div>
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody
            className={classNames(classes.tableBody, `tableBody_${tableName}`)}
          >
            {paginatedRows &&
              paginatedRows.length > 0 &&
              paginatedRows.map((user, i) => (
                <Row
                  key={i}
                  tableName={tableName}
                  classes={classes}
                  updateSourceInputs={updateSourceInputs}
                  sourceData={source_data}
                  headingRow={tableHeadColumns}
                  handleEditRow={handleEdit}
                  handleDeleteRow={handleDelete}
                  rowData={user}
                  setIsDeleteDialogOpen={setIsDeleteDialogOpen}
                  setCurrentDeletingRowData={setCurrentDeletingRowData}
                  setOpenFullRecordModal={setOpenFullRecordModal}
                  setCurrentRecord={setCurrentRecord}
                  index={i}
                  setIsEditMode={setIsEditMode}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* DELETE DIALOG */}
      <div>
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={isDeleteDialogOpen}
          onClose={() => setIsDeleteDialogOpen(false)}
        >
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent dividers>
            <DialogContentText>
              <p style={{ fontSize: "16px", color: "black" }}>
                The record will be deleted permanently. Do you want to continue?
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              disableFocusRipple
              variant="outlined"
              style={outlinedCNCButton}
              onClick={() => setIsDeleteDialogOpen(false)}
            >
              Cancel
            </Button>
            <Button
              disableFocusRipple
              style={containedButton}
              onClick={handleDelete}
            >
              Continue
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/* VIEW FULL RECORD DIALOG */}
      <ViewRecord
        tableName={tableName}
        heading={isEditMode ? "Edit Record" : "View Record"}
        isRowDataUpdating={isRowDataUpdating}
        setIsRowDataUpdating={setIsRowDataUpdating}
        modelData={currentRecord}
        closeModel={handleCloseModel}
        openModel={openFullRowRecordModal}
        selectClasses={classes}
        inputClasses={classes}
        updateSourceInputs={updateSourceInputs}
        sourceData={source_data}
        updateAlert={updateAlert}
        readOnly={!isEditMode}
        tableHeadColumns={tableHeadColumns}
        editModelColumnList={editModelColumnList}
        handleUpdateRow={handleUpdateRow}
      />

      {/* CREATE NEW DIALOG */}
      <CreateNewRecord
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        tableName={tableName}
        heading={"Add New Record"}
        tableHeadColumns={tableHeadColumns}
        editModelColumnList={editModelColumnList}
        modelData={currentRecord}
        selectClasses={classes}
        inputClasses={classes}
        updateSourceInputs={updateSourceInputs}
        sourceData={source_data}
        updateAlert={updateAlert}
        handleCreateNewRow={handleCreateNewRow}
        readOnly={false}
      />

      {TableData.length > 0 && (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={TableData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}

      {paginatedRows.length === 0 && (
        <div style={{ textAlign: "center" }}>
          {source_data?.current_mapped_data?.length > 0
            ? "No Match found"
            : `No ${usecaseLabel} Found`}
        </div>
      )}
    </>
  );
}

TableView.propTypes = {
  user: PropTypes.object,
  source_data: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TableView),
);
